var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"team-score"},[_c('ve-histogram',{attrs:{"width":"1134px","data":_vm.scoreData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }